import { CSSProperties } from "react"
import { faCircleArrowRight } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import cx from "classnames"

interface HighlightListItemType {
  heading: string
  text: string
}

export interface HighlightListProps {
  list: HighlightListItemType[]
  className?: string
}

const HighlightList = ({ list, className }: HighlightListProps) => {
  if (list.length === 0) {
    return null
  }

  return (
    <div
      className={cx(
        "flex flex-col gap-12 bg-grass-50 border-3 border-grass-700 rounded-sm py-[30px] px-5 lg:pl-[44px] lg:pr-[142px]",
        className
      )}
    >
      {list.map(({ heading, text }) => (
        <div key={heading} className="flex gap-3">
          <div className="w-7 h-7 shrink-0">
            <FontAwesomeIcon
              icon={faCircleArrowRight}
              title={faCircleArrowRight.iconName}
              className="pointer-events-none"
              style={
                {
                  fontSize: 28,
                  "--fa-primary-opacity": 1,
                  "--fa-secondary-opacity": 1,
                  "--fa-primary-color": "#000",
                  "--fa-secondary-color": "#86A393",
                } as CSSProperties
              }
              color="#86A393"
            />
          </div>

          <div>
            <h3 className="font-body font-bold leading-6 tracking-[0.96px]">
              {heading}
            </h3>

            <p className="text-sm font-body leading-[140%] tracking-[0.28px]">
              {text}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default HighlightList
